import { createContext } from "react";

const pageStore = createContext({
	pageLoading: false,
	setPageLoadingCtx: () => {},
});

export default pageStore;